var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-thank-you"},[(_vm.$store.getters.lastPagesSaved === 3)?_c('survey-thank-you'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }